import { apiRequest, getResource } from "../api/http";

// "We've missed you" emails to inactive users ("users" section: view to
// preview, edit to send).
const BASE = "/api/admin/winback";

const query = (params = {}) => {
  const entries = Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "");
  return entries.length ? `?${new URLSearchParams(entries).toString()}` : "";
};

/** Recipients of a segment: `{ segment: "inactive" | "never" | "both", days, skipRecent }` → `{ count, cooldownDays }`. */
export const getWinbackAudience = ({ criteria, ...params }) =>
  getResource(`${BASE}/audience${query({ ...params, criteria: criteria ? JSON.stringify(criteria) : undefined })}`, { fallback: null });

/** Exact email (nothing is sent): `{ userId?, mode, subject, message, lang, signed }` → `{ subject, html, to, lang }`. */
export const previewWinback = (body) => apiRequest("post", `${BASE}/preview`, { data: body, select: (data) => data.email, rethrow: true });

/**
 * Send to users (`{ userIds, ...message }`, resolves `{ result: { sent, skipped, failed } }`) or to a
 * whole segment (`{ segment, days, skipRecent, ...message }`, resolves `{ job }`, sent in the background).
 */
export const sendWinback = (body) => apiRequest("post", `${BASE}/send`, { data: body, rethrow: true });

/** Progress of the last group sending: `{ total, sent, skipped, failed, finishedAt, … }` or null. */
export const getWinbackJob = () => getResource(`${BASE}/job`, { select: (data) => data.job, fallback: null });

export const apiError = (error) => error?.response?.data?.message || "";
